import dayjs from 'dayjs';

// Portal Status radio values on the Contract Activity details page (UC 5.1)
export const PORTAL_STATUS = {
  HIRE_SEND: 'HIRE_SEND',
  HIRE_DNS: 'HIRE_DNS',
  TERM_SEND: 'TERM_SEND',
};

export const PORTAL_STATUS_LABELS = {
  [PORTAL_STATUS.HIRE_SEND]: 'Hire - Send to Benefits',
  [PORTAL_STATUS.HIRE_DNS]: 'Hire - DNS Do Not Send',
  [PORTAL_STATUS.TERM_SEND]: 'Term - Send Term to Benefits',
};

export const PAY_RATE_UNITS = [
  { label: 'Per Hour', value: 'PER_HOUR' },
  { label: 'Per Week', value: 'PER_WEEK' },
  { label: 'Per Year', value: 'PER_YEAR' },
  { label: 'Per Load', value: 'PER_LOAD' },
  { label: 'Per Mile', value: 'PER_MILE' },
  { label: 'Per Route', value: 'PER_ROUTE' },
  { label: 'Other (See Notes)', value: 'OTHER' },
];

export const PAY_TYPES = {
  HOURLY: 'HOURLY',
  SALARY: 'SALARY',
  OTHER: 'OTHER',
};

// Benefit Termination Date default until benefits are actually cancelled (UC 5.3)
export const MAX_BENEFIT_TERMINATION_DATE = '9999-12-31';

// Active Drivers window: contract activities ending within the last 96 hours,
// still open, or ending in the future (UC 3.1)
export const ACTIVE_WINDOW_DAYS = 4;

export const isDriverActive = driver =>
  !driver.latestActivityEndDate ||
  dayjs(driver.latestActivityEndDate).isAfter(dayjs().subtract(ACTIVE_WINDOW_DAYS, 'day').startOf('day'));

// "First Last - 470918" (UC 3.1)
export const driverLabel = driver =>
  [`${driver.firstName || ''} ${driver.lastName || ''}`.trim(), driver.driverId].filter(Boolean).join(' - ');

// "Client Name - 461055" (UC 3.1)
export const clientLabel = (name, id) => [name, id].filter(Boolean).join(' - ');

// Benefit Time Status derives from Pay Type (UC 5.3): Hourly=5, Salary=1, Other=blank
export const benefitTimeStatusFor = payType => {
  if (payType === PAY_TYPES.HOURLY) return '5';
  if (payType === PAY_TYPES.SALARY) return '1';
  return '';
};

// Active/All list sort: Last Name, First Name then Client Name (UC 3.1)
export const compareDrivers = (a, b) =>
  (a.lastName || '').localeCompare(b.lastName || '') ||
  (a.firstName || '').localeCompare(b.firstName || '') ||
  (a.currentClientName || '').localeCompare(b.currentClientName || '');

// CSV export with injection guard — same sanitization as SearchDQF
export const sanitizeCsvValue = value => {
  if (value === null || value === undefined) return '""';
  let sanitized = String(value).replace(/"/g, '""');
  if (/^[=+\-@\t\r]/.test(sanitized)) {
    sanitized = `'${sanitized}`;
  }
  return `"${sanitized}"`;
};

export const downloadCsv = (filename, headers, rows) => {
  const csv = [headers, ...rows].map(row => row.map(sanitizeCsvValue).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};
